import { Links } from 'application/constants/links';
import { RootPage } from 'pages/authorized/RootPage';
import { LoginPage } from 'pages/unauthorized/LoginPage';
import { createBrowserRouter } from 'react-router-dom';
import { ProjectListPage } from './authorized/projects/ProjectListPage';
import { UiKitPage } from './authorized/uikit/UiKitPage';
import { CreateRevisionPage } from './authorized/revisions/create/CreateRevisionPage';
import { ReactRouterErrorBoundary } from './ReactRouterErrorBoundary';
import { TemplateListPage } from './authorized/templates/TemplateListPage.tsx';
import { UseCookieAuth } from 'helpers/auth/auth-settings.ts';
import { ServerSideLoginPage } from './unauthorized/ServerSideLoginPage.tsx';
import { TemplatePage } from './authorized/templates/TemplatePage.tsx';
import { TemplateMergingPage } from './authorized/templates/TemplateMerging/TemplateMergingPage.tsx';
import { ProjectDetailsRootPage } from './authorized/projects/details/ProjectDetailsRootPage.tsx';
import { DocumentRootPage } from './authorized/documents/DocumentRootPage.tsx';

export const authorizedRoutes = () =>
  createBrowserRouter([
    {
      path: '/',
      element: <RootPage />,
      children: [
        {
          path: Links.Authorized.UiKit.route,
          element: <UiKitPage />,
        },
        {
          path: Links.Authorized.Templates.route,
          element: <TemplateListPage />,
        },
        {
          path: Links.Authorized.TemplatesMerging.route,
          element: <TemplateMergingPage />,
        },
        {
          path: Links.Authorized.Projects.route,
          element: <ProjectListPage />,
        },
        {
          path: Links.Authorized.ProjectDetails.route,
          element: <ProjectDetailsRootPage />,
        },
        {
          path: Links.Authorized.CreateRevision.route,
          element: <CreateRevisionPage />,
        },
        {
          path: Links.Authorized.CreateDocument.route,
          element: <DocumentRootPage />,
        },
        {
          path: Links.Authorized.OpenDocument.route,
          element: <DocumentRootPage />,
        },
        {
          path: Links.Authorized.OpenTemplate.route,
          element: <TemplatePage />,
        },
        { path: '', element: <ProjectListPage /> },
      ],
      ErrorBoundary: ReactRouterErrorBoundary,
    },
  ]);
export const anonymousRoutes = () =>
  createBrowserRouter([
    {
      path: '*',
      element: UseCookieAuth ? <LoginPage /> : <ServerSideLoginPage />,
      ErrorBoundary: ReactRouterErrorBoundary,
    },
  ]);
